import React, { useEffect } from 'react';
import PublicFooter from './PublicFooter';
import PublicHeader from './PublicHeader';

const PublicLayout = ({ children, offsetHeader = true }) => {
  useEffect(() => {
    document.body.classList.add('public-page-body');

    return () => {
      document.body.classList.remove('public-page-body');
    };
  }, []);

  return (
    <div className="public-layout">
      <PublicHeader />
      <main className={`public-main${offsetHeader ? ' public-main--offset' : ''}`}>{children}</main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
